export enum FormattingType {
    Money = 'money',
    Date = 'date',
    Percent = 'percent',
}
